module.exports = __webpack_public_path__ + "img/undo.aec4c409.svg";